<script setup>
import {onMounted, ref} from "vue";
import AdminNewReservation from "./AdminNewReservation.vue";

const props = defineProps({
    notification: Object,
})
const reservation = ref();
onMounted(() => {
    axios.get(`/app/reservations/r/${props.notification?.data.reservation}`).then((data) => reservation.value = data.data);
})
</script>

<template>
    <admin-new-reservation v-if="reservation" v-model="reservation"></admin-new-reservation>
</template>

<style scoped lang="scss">

</style>
